import React, { useState } from 'react'
import { Typography, withStyles, InputAdornment } from '@material-ui/core'
import { CoreTextField, CoreButton, CoreIconButton } from 'src/components/core'
import { Icon } from '@iconify/react'
import SuccessAlert from './SuccessAlert'
import styles from '../styles'

const EmailSettings = ({
  classes,
  apiToken,
  onApiTokenChange,
  sendingDomain,
  onSendingDomainChange,
  senderName,
  onSenderNameChange,
  isValidEmail,
  onSave,
  disabled,
  provider,
}) => {
  const [showApiKey, setShowApiKey] = useState(false)
  const [showSuccess, setShowSuccess] = useState(false)

  const handleShowApiKey = () => {
    setShowApiKey(!showApiKey)
  }

  const handleSave = () => {
    onSave()
    setShowSuccess(true)
  }

  const providerLabels = {
    0: 'SendGrid',
    1: 'MailChimp',
    2: 'MailerSend',
  }

  return (
    <div className={classes.settingsContainer}>
      <Typography className={classes.settingsTitle}>
        SendGrid Settings
      </Typography>
      <div className={classes.settingsFields}>
        <CoreTextField
          placeholder="sk-abc123..."
          label={`${providerLabels[provider]} API Token`}
          value={apiToken}
          onChange={onApiTokenChange}
          fullWidth
          type={showApiKey ? 'text' : 'password'}
          error={apiToken.length > 0 && apiToken.length < 10}
          helperText={
            apiToken.length > 0 && apiToken.length < 10
              ? 'API token should be at least 10 characters'
              : ''
          }
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <CoreIconButton
                  onClick={handleShowApiKey}
                  edge="end"
                  color="dark"
                  variant="text"
                >
                  {showApiKey ? (
                    <Icon icon="mdi:eye" />
                  ) : (
                    <Icon icon="mdi:eye-off" />
                  )}
                </CoreIconButton>
              </InputAdornment>
            ),
          }}
        />
        <CoreTextField
          label="Sending domain"
          placeholder="noreply@email.com"
          value={sendingDomain}
          onChange={onSendingDomainChange}
          fullWidth
          error={sendingDomain.length > 0 && !isValidEmail(sendingDomain)}
          helperText={
            sendingDomain.length > 0 && !isValidEmail(sendingDomain)
              ? 'Please enter a valid email address'
              : ''
          }
        />
        <CoreTextField
          placeholder="No-reply"
          label="Sender name"
          value={senderName}
          onChange={onSenderNameChange}
          fullWidth
          error={senderName.length > 0 && senderName.trim().length < 2}
          helperText={
            senderName.length > 0 && senderName.trim().length < 2
              ? 'Sender name should be at least 2 characters'
              : ''
          }
        />
      </div>
      <CoreButton
        variant="contained"
        color="primary"
        onClick={handleSave}
        disabled={disabled}
        className={classes.saveButton}
      >
        Save settings
      </CoreButton>
      <SuccessAlert show={showSuccess} onHide={() => setShowSuccess(false)} />
    </div>
  )
}

export default withStyles(styles)(EmailSettings)
